module.exports = __webpack_public_path__ + "static/img/ind_ban_014.c9d29471.jpeg";